import { render, staticRenderFns } from "./ClinicIncomeReport.vue?vue&type=template&id=6f07f84d&scoped=true"
import script from "./ClinicIncomeReport.vue?vue&type=script&lang=js"
export * from "./ClinicIncomeReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f07f84d",
  null
  
)

export default component.exports